<template>
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g filter="url(#filter0_f_6933_743)">
      <rect x="8.5" y="9" width="21" height="21" fill="url(#pattern0_6933_743)" />
    </g>
    <g opacity="0.6">
      <rect x="4" y="1" width="30" height="30" rx="9.23077" fill="#D8D8D8" />
      <mask
        id="mask0_6933_743"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="4"
        y="1"
        width="30"
        height="30"
      >
        <rect x="4" y="1" width="30" height="30" rx="9.23077" fill="white" />
      </mask>
      <g mask="url(#mask0_6933_743)">
        <g filter="url(#filter1_f_6933_743)">
          <rect
            x="4"
            y="-0.154297"
            width="32.3077"
            height="32.3077"
            fill="url(#paint0_linear_6933_743)"
          />
        </g>
        <mask
          id="mask1_6933_743"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="4"
          y="-1"
          width="33"
          height="34"
        >
          <rect x="4" y="-0.154297" width="32.3077" height="32.3077" fill="white" />
        </mask>
        <g mask="url(#mask1_6933_743)">
          <g filter="url(#filter2_f_6933_743)">
            <ellipse cx="19.5" cy="16.5" rx="8.5" ry="10.5" fill="#00BE7F" />
          </g>
          <g filter="url(#filter3_f_6933_743)">
            <ellipse cx="31.6929" cy="38.4992" rx="16.1538" ry="14.4231" fill="#00FF84" />
          </g>
          <g filter="url(#filter4_f_6933_743)">
            <ellipse cx="-1.84615" cy="20" rx="16.1538" ry="15" fill="#18CCDB" />
          </g>
          <g filter="url(#filter5_f_6933_743)">
            <circle cx="36.2409" cy="-3.75914" r="13.2409" fill="#F4F748" />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_6933_743"
        x="0.345155"
        y="0.845155"
        width="37.3097"
        height="37.3097"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.07742" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <pattern id="pattern0_6933_743" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0_6933_743" transform="scale(0.0625)" />
      </pattern>
      <filter
        id="filter1_f_6933_743"
        x="-8.54592"
        y="-12.7002"
        width="57.4004"
        height="57.4004"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6.27296" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <filter
        id="filter2_f_6933_743"
        x="-23.5013"
        y="-28.5013"
        width="86.0025"
        height="90.0025"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="17.2506" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <filter
        id="filter3_f_6933_743"
        x="-15.8257"
        y="-7.28862"
        width="95.0382"
        height="91.5753"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="15.6824" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <filter
        id="filter4_f_6933_743"
        x="-29.7618"
        y="-6.7618"
        width="55.8322"
        height="53.5236"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5.8809" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <filter
        id="filter5_f_6933_743"
        x="1.04465"
        y="-38.9554"
        width="70.3912"
        height="70.3931"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="10.9777" result="effect1_foregroundBlur_6933_743" />
      </filter>
      <linearGradient
        id="paint0_linear_6933_743"
        x1="21"
        y1="-7.50049"
        x2="4"
        y2="32.1534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DF563" />
        <stop offset="0.533946" stop-color="#14C129" />
        <stop offset="1" stop-color="#A7FDFF" />
      </linearGradient>
      <image
        id="image0_6933_743"
        width="16"
        height="16"
        preserveAspectRatio="none"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAq1JREFUOE8tk81uHEUUhb9zb1V194yEs8jWErDIJixYsEV5BNjaC1YofoWIF+AVcJBYBpYREmKHki3CEY7Ij5AiIiVOcMZO7LE9057urkI94UpVJZV0vjr3qo74v74/uLVVtNgxtdeT5Y1QhthoIFlHrczEcxfVnaaSH9Vmu9c27v44SjVu3774ZncYTm56aIm6JKin8kxdMs14kpmoUIWBlEUyqLDbn1z5eUe3nn23tbB/7sA7qjBHtDTKJPVMrVCp0Ij1mnohlvFOJDnR07a+fvrDvZU/vzHoEOmY2lom1lH5QA00NtoXDYVaUBeo3alGQEn39cXjn2Z9Priq8C/igGBzalvSWE9j48uF2mAy2paYmEgEKhlNqY70+f4vXdHrIB0gf40PM0I8Y2orJhqobQSIeg3Se6GMpESjutOnD34r0hGUV4T4EmOG2wmRMxpfrV0kiTpAVSCZ02gEVUxVo2t7vxfjLdIbgr3AdIjxhqgzoi+JlkmWqSXi2gkEBRolpjZBH+39WaQ5gdl7sV5hmhF8TrCWYCuCZ7wU3ApJRizGNCSmatDmH38VtwuivcU5RH6I2TFJc2TneABXjwFGxs1JGBWRqVVoc+/xylnGaKcEP163Ev0d5qeYXeKhRxp/XAEGogvLgVrOZBzi5t7TWVB7NdoZKZwS7YgYL5DO8bhEloEOzCD3eBBWjFTiOIcjffjgyT231Y3al1R2SkpnmM9JcYG8p6iHNQSKDFSwIkIWlaf7+nj/762K9k4TLmniOSktSL7AvAVfkRkoDoMKhZ6xnzFAAaPBt9dh+uzhw90mrW42oaVKLcFbzFdrQG8Dg2UGZUYfuWRkwmW3f/3gq501YKwvn+1vNX6xE0J33WJ3xawLgy7plOks01vpi4aTkssjU9m9u7G9jvN/JZcHcUi3ZicAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
</template>
